import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";

import ButtonPrimary from '../../components/ButtonPrimary';

import SelectBreed from "./components/SelectBreed";
import SelectDietaryGoals from "./components/SelectDietaryGoals";
import SelectPetType from "./components/SelectPetType";

const selectClasslist = 'w200 w175@lg w130@md w100%@md mr0@sm bdrs8 oh bd2-s-gray-light';

export default function SiteFilters({ className, breeds, dietaryGoals, petTypes }) {
  const [ searchParams ] = useSearchParams();

  const [ petType, setPetType ] = useState(searchParams.get('petType') || '0');
  const [ breed, setBreed ] = useState(searchParams.get('breed') || '0');
  const [ dietaryGoal, setDietaryGoal ] = useState(searchParams.get('dietaryGoal') || '0');

  const [ filteredBreeds, setFilteredBreeds ] = useState(breeds);

  useEffect(() => {
    if(petType !== '0') {
      let petTypeId = petType + '';
      setFilteredBreeds(breeds.filter(breed => petTypeId === '0' || breed.petType.ID === petTypeId))
    }
  },[])

  const updatePetType = petTypeId => {
    setPetType(petTypeId);
    setFilteredBreeds(breeds.filter(breed => petTypeId === '0' || breed.petType.ID === petTypeId));
    setBreed('0');
  }
  const updateBreed = breedId => {
    setBreed(breedId);
  }
  const updateDietaryGoal = dietaryGoal => {
    setDietaryGoal(dietaryGoal);
  }

  return (
  <div className={`site-filters c-black df jcsb aic fxdrc@md g10 ${ className || '' }`}>
    <SelectPetType
      className={selectClasslist}
      value={petType}
      data={petTypes}
      setValue={updatePetType}
    />
    <SelectBreed
      className={selectClasslist}
      value={breed}
      data={filteredBreeds}
      setValue={updateBreed}
    />
    <SelectDietaryGoals
      className={selectClasslist}
      value={dietaryGoal}
      data={dietaryGoals}
      setValue={updateDietaryGoal}
    />
    <ButtonPrimary
      className="pl24@lg pr24@lg mt0@sm w160 w100%@md h48@sm search-button-true-stories"
      href={`/apps/truestories/story/search?petType=${petType||0}&breed=${breed||0}&dietaryGoal=${dietaryGoal||0}&page=0`}
    >
      Search
    </ButtonPrimary>
  </div>
  );
}
